import PropTypes from 'prop-types'

import {atomIconSizes} from '@s-ui/react-atom-icon'
import {useSuiContext} from '@s-ui/react-context'
import IconInfoOutline from '@adv-mt/mt-svg-icons/lib/InfoOutline.js'
import IconWavyCheckOutline from '@adv-mt/mt-svg-icons/lib/WavyCheckOutline.js'
import {Badge, BADGE_DESIGNS, BADGE_INTENTS, BADGE_SIZES} from '@adv-mt/ui/badge'
import {Button, BUTTON_SHAPES, BUTTON_SIZES, BUTTON_VARIANTS} from '@adv-mt/ui/button'
import {Popover, PopoverContent, PopoverTrigger} from '@adv-mt/ui/popover'
import {Body2} from '@adv-mt/ui/typography'

const TERMS_RATINGS_HASH = '#18-condiciones-del-servicio-de-valoraciones'

const DealerRatingsDisclaimer = ({className = ''}) => {
  const {domain, i18n} = useSuiContext()

  const {TERMS_OF_SERVICE_PATH_PATTERN} = domain.get('config').get('page')

  return (
    <div className={className}>
      <Badge
        iconLeft={<IconWavyCheckOutline size={atomIconSizes.small} />}
        design={BADGE_DESIGNS.SOFT}
        intent={BADGE_INTENTS.SUCCESS}
        size={BADGE_SIZES.MEDIUM}
      >
        {i18n.t('DEALER_RATINGS.DISCLAIMER.TEXT')}
      </Badge>

      <Popover>
        <PopoverTrigger
          render={
            <Button
              aria-label={i18n.t('DEALER_RATINGS.DISCLAIMER.TOOLTIP.TRIGGER_LABEL')}
              shape={BUTTON_SHAPES.CIRCLE}
              size={BUTTON_SIZES.MEDIUM}
              variant={BUTTON_VARIANTS.FLAT}
            >
              <IconInfoOutline size={atomIconSizes.medium} />
            </Button>
          }
        />

        <PopoverContent className={`${className}-tooltip`}>
          <Body2 className="text-inherit">{i18n.t('DEALER_RATINGS.DISCLAIMER.TOOLTIP.SUBTITLE')}</Body2>

          <Button
            href={`${TERMS_OF_SERVICE_PATH_PATTERN}/${TERMS_RATINGS_HASH}`}
            shape={BUTTON_SHAPES.CIRCLE}
            size={BUTTON_SIZES.MEDIUM}
            variant={BUTTON_VARIANTS.OUTLINE}
            negative
          >
            {i18n.t('COMMON_MORE_INFO')}
          </Button>
        </PopoverContent>
      </Popover>
    </div>
  )
}

DealerRatingsDisclaimer.displayName = 'DealerRatingsDisclaimer'
DealerRatingsDisclaimer.propTypes = {
  className: PropTypes.string
}

export default DealerRatingsDisclaimer
